export const setOid2Cookie = () => {
    // 没有oid再设置
    if (document.cookie.indexOf('oid') === -1) {
        const oid = window.Omega?.context.omgId;
        if (oid) {
            document.cookie = `oid=${oid};path=/`
        }
    }
}